import React, {useState} from 'react'
import axios from 'axios'

function CategoriasItemDetalle(props) {
  const categoria = props.categoria

  const [inputFile, setInputFile] = useState('')
  const [nombreInput, setNombreInput] = useState('')

  let idElementoNum = categoria.idElement.split('-')[2]
  let nombreString = categoria.name

  const onChangeImage = (event) => {
    setInputFile(event.target.files)
    const [file] = event.target.files
    if (file) {
      document
        .getElementsByClassName('home-categorias-' + idElementoNum)[0]
        .setAttribute('src', URL.createObjectURL(file))
      document.getElementById('ribbon-categorias-' + idElementoNum).classList.remove('d-none')
    }
  }

  const onChangeNombre = (event) => {
    setNombreInput(event.target.value)
    document.getElementById('ribbon-categorias-' + idElementoNum).classList.remove('d-none')
  }

  const onSubmit = () => {
    const API_URL = process.env.REACT_APP_API_URL

    const data = new FormData()

    for (let i = 0; i < inputFile.length; i++) {
      data.append('file[]', inputFile[i])
    }

    data.append('name', categoria.idElement)
    data.append('elementName', document.getElementById('nombre-categorias-' + idElementoNum).value)

    axios.post(API_URL + '/new-categoria-home', data, {}).then(
      (res) => {
        console.log(res)
        document.getElementById('ribbon-categorias-' + idElementoNum).classList.add('d-none')
      },
      (error) => {
        alert(error)
      }
    )
  }

  return (
    <div className='col-lg-2 categoriasitem' key={categoria.idElement}>
      <div className='card card-custom overlay overflow-hidden bg-white'>
        <div className='card-body p-0 ribbon'>
          <div id={'ribbon-categorias-' + idElementoNum} className='ribbon-label bg-danger d-none'>
            Sin guardar
          </div>
          <div className='overlay-wrapper'>
            <img
              src={categoria.url}
              alt=''
              className={'w-100 rounded home-categorias-' + idElementoNum}
            />
          </div>
          <div className='overlay-layer bg-dark bg-opacity-10'>
            <div className='d-flex flex-grow-1 flex-center py-5'>
              <input
                type='file'
                id={'file-categorias-' + idElementoNum}
                name={'file-categorias-' + idElementoNum}
                className='input-image'
                onChange={(event) => onChangeImage(event)}
              />
              <input
                id={'button-categorias-' + idElementoNum}
                type='button'
                value='Cambiar...'
                className='btn btn-light-primary'
                onClick={() => document.getElementById('file-categorias-' + idElementoNum).click()}
              />
            </div>
          </div>
        </div>
      </div>
      <label className='form-label mt-6'>Nombre</label>
      <input
        id={'nombre-categorias-' + idElementoNum}
        name={'nombre-categorias-' + idElementoNum}
        className='form-control'
        defaultValue={nombreString}
        type='text'
        onChange={(e) => onChangeNombre(e)}
      />
      <div className='mt-4 float-end'>
        <button className='btn btn-primary btn-sm' onClick={() => onSubmit()}>
          Guardar
        </button>
        <button
          className='btn btn-danger float-end btn-sm ms-2'
          onClick={() => props.deleteCategoria(categoria.idElement)}
        >
          Eliminar
        </button>
      </div>
    </div>
  )
}

export {CategoriasItemDetalle}
